// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

export type PjpCategorySummaryModelType = {
    outletCount: number,
    executiveCount: number,
    beatCount: number,
    averageDistancePerBeat: number,
    standardDeviationOfOutletsPerBeat: number,
    numberOfUnallocatedTasks: number,
    averageOutletsPerDay: number,
    standardDeviationOfOutletsPerDay: number,
    averageBeatsPerDay: number,
    standardDeviationOfBeatsPerDay: number,
    salesmanFamiliarityPercentage: number,
    channelFamiliarityPercentage: number,
    totalTravelingDistanceExcludingHub: number,
    totalTravelingTimeExcludingHub: number,
    averageRevenuePerDay: number,
    standardDeviationOfRevenuePerDay: number,
    averageRevenuePerBeat: number,
    standardDeviationOfRevenuePerBeat: number,
    serviceabilityRatio: number,
    totalTransactingTime: number,
    totalTravelingTime: number,
    outletsPerBeatCount: number,
    averageTat: number
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PjpCategorySummary extends ImmutableModel {
    static fromJS(json: PjpCategorySummaryModelType): PjpCategorySummary {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): PjpCategorySummaryModelType {
        return {
            outletCount: this.outletCount,
            executiveCount: this.executiveCount,
            beatCount: this.beatCount,
            averageDistancePerBeat: this.averageDistancePerBeat,
            standardDeviationOfOutletsPerBeat: this
                .standardDeviationOfOutletsPerBeat,
            numberOfUnallocatedTasks: this.numberOfUnallocatedTasks,
            averageOutletsPerDay: this.averageOutletsPerDay,
            standardDeviationOfOutletsPerDay: this
                .standardDeviationOfOutletsPerDay,
            averageBeatsPerDay: this.averageBeatsPerDay,
            standardDeviationOfBeatsPerDay: this.standardDeviationOfBeatsPerDay,
            salesmanFamiliarityPercentage: this.salesmanFamiliarityPercentage,
            channelFamiliarityPercentage: this.channelFamiliarityPercentage,
            totalTravelingDistanceExcludingHub: this
                .totalTravelingDistanceExcludingHub,
            totalTravelingTimeExcludingHub: this.totalTravelingTimeExcludingHub,
            averageRevenuePerDay: this.averageRevenuePerDay,
            standardDeviationOfRevenuePerDay: this
                .standardDeviationOfRevenuePerDay,
            averageRevenuePerBeat: this.averageRevenuePerBeat,
            standardDeviationOfRevenuePerBeat: this
                .standardDeviationOfRevenuePerBeat,
            serviceabilityRatio: this.serviceabilityRatio,
            totalTransactingTime: this.totalTransactingTime,
            totalTravelingTime: this.totalTravelingTime,
            outletsPerBeatCount: this.outletsPerBeatCount,
            averageTat: this.averageTat
        };
    }

    get outletCount(): number {
        return this._state.get('outletCount');
    }

    setOutletCount(outletCount: number): this {
        return this.clone(this._state.set('outletCount', outletCount));
    }

    get executiveCount(): number {
        return this._state.get('executiveCount');
    }

    setExecutiveCount(executiveCount: number): this {
        return this.clone(this._state.set('executiveCount', executiveCount));
    }

    get beatCount(): number {
        return this._state.get('beatCount');
    }

    setBeatCount(beatCount: number): this {
        return this.clone(this._state.set('beatCount', beatCount));
    }

    get averageDistancePerBeat(): number {
        return this._state.get('averageDistancePerBeat');
    }

    setAverageDistancePerBeat(averageDistancePerBeat: number): this {
        return this.clone(
            this._state.set('averageDistancePerBeat', averageDistancePerBeat)
        );
    }

    get standardDeviationOfOutletsPerBeat(): number {
        return this._state.get('standardDeviationOfOutletsPerBeat');
    }

    setStandardDeviationOfOutletsPerBeat(
        standardDeviationOfOutletsPerBeat: number
    ): this {
        return this.clone(
            this._state.set(
                'standardDeviationOfOutletsPerBeat',
                standardDeviationOfOutletsPerBeat
            )
        );
    }

    get numberOfUnallocatedTasks(): number {
        return this._state.get('numberOfUnallocatedTasks');
    }

    setNumberOfUnallocatedTasks(numberOfUnallocatedTasks: number): this {
        return this.clone(
            this._state.set(
                'numberOfUnallocatedTasks',
                numberOfUnallocatedTasks
            )
        );
    }

    get averageOutletsPerDay(): number {
        return this._state.get('averageOutletsPerDay');
    }

    setAverageOutletsPerDay(averageOutletsPerDay: number): this {
        return this.clone(
            this._state.set('averageOutletsPerDay', averageOutletsPerDay)
        );
    }

    get standardDeviationOfOutletsPerDay(): number {
        return this._state.get('standardDeviationOfOutletsPerDay');
    }

    setStandardDeviationOfOutletsPerDay(
        standardDeviationOfOutletsPerDay: number
    ): this {
        return this.clone(
            this._state.set(
                'standardDeviationOfOutletsPerDay',
                standardDeviationOfOutletsPerDay
            )
        );
    }

    get averageBeatsPerDay(): number {
        return this._state.get('averageBeatsPerDay');
    }

    setAverageBeatsPerDay(averageBeatsPerDay: number): this {
        return this.clone(
            this._state.set('averageBeatsPerDay', averageBeatsPerDay)
        );
    }

    get standardDeviationOfBeatsPerDay(): number {
        return this._state.get('standardDeviationOfBeatsPerDay');
    }

    setStandardDeviationOfBeatsPerDay(
        standardDeviationOfBeatsPerDay: number
    ): this {
        return this.clone(
            this._state.set(
                'standardDeviationOfBeatsPerDay',
                standardDeviationOfBeatsPerDay
            )
        );
    }

    get salesmanFamiliarityPercentage(): number {
        return this._state.get('salesmanFamiliarityPercentage');
    }

    setSalesmanFamiliarityPercentage(
        salesmanFamiliarityPercentage: number
    ): this {
        return this.clone(
            this._state.set(
                'salesmanFamiliarityPercentage',
                salesmanFamiliarityPercentage
            )
        );
    }

    get channelFamiliarityPercentage(): number {
        return this._state.get('channelFamiliarityPercentage');
    }

    setChannelFamiliarityPercentage(
        channelFamiliarityPercentage: number
    ): this {
        return this.clone(
            this._state.set(
                'channelFamiliarityPercentage',
                channelFamiliarityPercentage
            )
        );
    }

    get totalTravelingDistanceExcludingHub(): number {
        return this._state.get('totalTravelingDistanceExcludingHub');
    }

    setTotalTravelingDistanceExcludingHub(
        totalTravelingDistanceExcludingHub: number
    ): this {
        return this.clone(
            this._state.set(
                'totalTravelingDistanceExcludingHub',
                totalTravelingDistanceExcludingHub
            )
        );
    }

    get totalTravelingTimeExcludingHub(): number {
        return this._state.get('totalTravelingTimeExcludingHub');
    }

    setTotalTravelingTimeExcludingHub(
        totalTravelingTimeExcludingHub: number
    ): this {
        return this.clone(
            this._state.set(
                'totalTravelingTimeExcludingHub',
                totalTravelingTimeExcludingHub
            )
        );
    }

    get averageRevenuePerDay(): number {
        return this._state.get('averageRevenuePerDay');
    }

    setAverageRevenuePerDay(averageRevenuePerDay: number): this {
        return this.clone(
            this._state.set('averageRevenuePerDay', averageRevenuePerDay)
        );
    }

    get standardDeviationOfRevenuePerDay(): number {
        return this._state.get('standardDeviationOfRevenuePerDay');
    }

    setStandardDeviationOfRevenuePerDay(
        standardDeviationOfRevenuePerDay: number
    ): this {
        return this.clone(
            this._state.set(
                'standardDeviationOfRevenuePerDay',
                standardDeviationOfRevenuePerDay
            )
        );
    }

    get averageRevenuePerBeat(): number {
        return this._state.get('averageRevenuePerBeat');
    }

    setAverageRevenuePerBeat(averageRevenuePerBeat: number): this {
        return this.clone(
            this._state.set('averageRevenuePerBeat', averageRevenuePerBeat)
        );
    }

    get standardDeviationOfRevenuePerBeat(): number {
        return this._state.get('standardDeviationOfRevenuePerBeat');
    }

    setStandardDeviationOfRevenuePerBeat(
        standardDeviationOfRevenuePerBeat: number
    ): this {
        return this.clone(
            this._state.set(
                'standardDeviationOfRevenuePerBeat',
                standardDeviationOfRevenuePerBeat
            )
        );
    }

    get serviceabilityRatio(): number {
        return this._state.get('serviceabilityRatio');
    }

    setServiceabilityRatio(serviceabilityRatio: number): this {
        return this.clone(
            this._state.set('serviceabilityRatio', serviceabilityRatio)
        );
    }

    get totalTransactingTime(): number {
        return this._state.get('totalTransactingTime');
    }

    setTotalTransactingTime(totalTransactingTime: number): this {
        return this.clone(
            this._state.set('totalTransactingTime', totalTransactingTime)
        );
    }

    get totalTravelingTime(): number {
        return this._state.get('totalTravelingTime');
    }

    setTotalTravelingTime(totalTravelingTime: number): this {
        return this.clone(
            this._state.set('totalTravelingTime', totalTravelingTime)
        );
    }

    get outletsPerBeatCount(): number {
        return this._state.get('outletsPerBeatCount');
    }

    setOutletsPerBeatCount(outletsPerBeatCount: number): this {
        return this.clone(
            this._state.set('outletsPerBeatCount', outletsPerBeatCount)
        );
    }

    get averageTat(): number {
        return this._state.get('averageTat');
    }

    setAverageTat(averageTat: number): this {
        return this.clone(this._state.set('averageTat', averageTat));
    }
}
